import type { TransferGapRiskLevel } from "@care-by-ella/contracts";

// TES-728 — the derived risk of a gap in treatment. A-02 names it
// "risk för behandlingsglapp": a queue column, not a patient statement.
// One map for the queue and the case view, which used to carry a copy each.
//
// TES-1046 (Ö-290) — "Hög" is orange, never red. A gap is an urgent
// operational continuity risk, not an acute medical classification; red is
// reserved for clinically acute safety signals, which are shown and routed on
// their own. It borrows the apricot ink + fill of the status tones
// (TES-1037), the family the palette keeps clearly apart from the risk tone.
// Classes are written out in full so Tailwind's scanner finds them.
//
// Pure (no React), so `node --test` can run it.
export const GAP_RISK_BADGE: Record<
  TransferGapRiskLevel,
  { label: string; className: string }
> = {
  high: {
    label: "Hög",
    className:
      "border-status-missing-ink bg-status-missing-fill text-status-missing-ink",
  },
  medium: { label: "Medel", className: "border-warning text-warning" },
  low: { label: "Låg", className: "border-success text-success" },
  unknown: {
    label: "Okänd",
    className: "border-borderSubtle text-textSecondary",
  },
};
